export const CENTER_ALIGN_FEATURES = 3;
export const MAX_TOP_FEATURES = 4;
export const FIRST_ELEMENT = 0;
